import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationCenter = ({ notifications }) => {
  const [filter, setFilter] = useState('all');

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return 'CheckCircle2';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'success':
        return 'text-success bg-success/10';
      case 'warning':
        return 'text-warning bg-warning/10';
      case 'error':
        return 'text-error bg-error/10';
      case 'info':
        return 'text-primary bg-primary/10';
      default:
        return 'text-muted bg-muted';
    }
  };

  const filteredNotifications = filter === 'all' 
    ? notifications 
    : notifications?.filter(n => n?.type === filter);

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Notifications</h3>
          <p className="text-xs md:text-sm text-muted-foreground">{notifications?.length} unread messages</p>
        </div>
        <div className="p-2 rounded-lg bg-primary/10 text-primary">
          <Icon name="Bell" size={20} />
        </div>
      </div>
      <div className="flex gap-2 mb-4 overflow-x-auto scrollbar-hide">
        {['all', 'success', 'warning', 'error', 'info']?.map((type) => (
          <Button
            key={type}
            variant={filter === type ? 'default' : 'outline'}
            size="sm"
            onClick={() => setFilter(type)}
            className="flex-shrink-0 capitalize"
          >
            {type}
          </Button>
        ))}
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {filteredNotifications?.map((notification, index) => (
          <div 
            key={index} 
            className="flex items-start gap-3 p-3 hover:bg-muted/50 rounded-lg transition-colors duration-200"
          >
            <div className={`p-2 rounded-lg flex-shrink-0 ${getNotificationColor(notification?.type)}`}>
              <Icon name={getNotificationIcon(notification?.type)} size={16} />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-medium text-foreground mb-1 line-clamp-2">{notification?.title}</p>
              <p className="text-xs text-muted-foreground line-clamp-2 mb-2">{notification?.message}</p>
              <span className="text-xs text-muted-foreground">{notification?.time}</span>
            </div>

            {!notification?.read && (
              <div className="w-2 h-2 bg-primary rounded-full flex-shrink-0 mt-2"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationCenter;